export default __webpack_public_path__ + "static/media/remove-customers.5f2e9077.svg";